import Vue from "vue";
import Router from "vue-router";
import vmApp from "./index.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path:'/',
      redirect:'/en'
    },
    {
           path:'/:lang?',component:vmApp,
          
           children:[
          {
            path: "/",
            name: "home",
            meta: {
              title: "",
              Description: "",
              Keywords: "",
              component: "appPageHome",
              index: 0,
              indexsub: -1,
              headerColor: "clear"
            }
          },
          {
            path: "salameh/grocery",
            name: "grocery",
            meta: {
              title: "",
              Description: "",
              Keywords: "",
              component: "appPageNavalVessels",
              index: 1,
              indexsub: 0,
              headerColor: "clear"
            }
          },
          {
            path: "salameh/bread",
            name: "equipment",
            meta: {
              title: "",
              Description: "",
              Keywords: "",
              component: "appPageEquipment",
              index: 1,
              indexsub: -1,
              headerColor: "clear"
            }
          },
          {
            path: "salameh/lebanese-snack",
            name: "operations",
            meta: {
              title: "",
              Description: "",
              Keywords: "",
              component: "appPageOperations",
              index: 1,
              indexsub: -1,
              headerColor: "clear"
            }
          },
          {
            path: "salameh/chicken-and-meat",
            name: "sectors",
            meta: {
              title: "",
              Description: "",
              Keywords: "",
              component: "appPageSectors",
              index: 2,
              indexsub: -1,
              headerColor: "clear"
            }
          },

          {
            path: "salameh/charcuterie-and-fromagerie",
            name: "charcuterieAndFromagerie",
            meta: {
              title: "",
              Description: "",
              Keywords: "",
              component: "appPageQualityPolicy",
              index: 3,
              indexsub: -1,
              headerColor: "clear"
            }
          },
          
          {
            path: "salameh/dairy-products",
            name: "occupational-health",
            meta: {
              title: "",
              Description: "",
              Keywords: "",
              component: "appPageOccupationalhealth",
              index: 4,
              indexsub: -1,
              headerColor: "clear"
            }
          },
          
          {
            path: "salameh/contact",
            name: "Contact",
            meta: {
              title: "",
              Description: "",
              Keywords: "",
              component: "appPageContact",
              index: 5,
              indexsub: -1,
              headerColor: "clear"
            }
          },
          {
            path: "*",
            name: "404",
            meta: {
              component: "appPage404",
              title: "Resource Group  | 404",
              headerColor: "clear"
            }
          }
        ]

      }
  ]
});
